import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoSolvenciaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoSolvenciaPage",
            ss: ss,
            auth: {},
            ajax: {
                "url": ss.indexTipoSolvencia(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoSolvencia', name: 'TipoSolvencia', title: 'Tipo Solvencia' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            TipoSolvencias: [],
            TipoSolvencia: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoSolvencia() {
            this.TipoSolvencia = {};
            this.$refs['frm-TipoSolvencia'].show();
        },
        showTipoSolvencia(id) {
            this.isLoading=true;
            this.ss.showTipoSolvencia(id).then(
                (result) => {
                    let response = result.data;
                    this.TipoSolvencia = response.data;
                    this.$refs['view-TipoSolvencia'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoSolvencia() {
            this.$refs['frm-TipoSolvencia'].show();
            this.$refs['view-TipoSolvencia'].hide();
        },
        cancelTipoSolvencia() {
            if (this.TipoSolvencia.id) {
                this.$refs['view-TipoSolvencia'].show();
            }
            this.$refs['frm-TipoSolvencia'].hide();
        },
        saveTipoSolvencia() {
            this.ss.storeTipoSolvencia(this.TipoSolvencia).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-TipoSolvencia'].hide();
                    this.$refs['datatable-TipoSolvencia'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoSolvencia() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoSolvencia(this.TipoSolvencia)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-TipoSolvencia'].hide();
                                this.$refs['datatable-TipoSolvencia'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoSolvencia').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoSolvencia(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
